/**
 * @desc 财务画像-基础信息-主营业务变动
 */
import React from 'react';
import BBDPie from '../../../common/echarts/BBDPie';
import style from '../common/assetLiabilities.scss';
import { numberFixed, overtopOmit } from '../../../../utils/formatter';
export default function DataTransitPie({data}) {
    let option = lineOption(data);

    return (
        <div className={style.dataTransitPie}>
            <BBDPie option={option} />
        </div>
    );
}

function lineOption(data) {
    let legendData = [], clientlabels = [];
    data.map(item => {
        clientlabels.push(item.name);
        legendData.push(item.value);
    });
    return {
        tooltip: {
            formatter: (data) => {
                return data.name + '  ' + numberFixed(data.value * 100) + '%';
            }
        },
        legend: {
            type: 'scroll',
            left: '39%',
            height: 128,
            formatter: name => {
                let index = 0;
                clientlabels.forEach(function (value, i) {
                    if (value === name) {
                        index = i;
                    }
                });
                return overtopOmit(8, name) + '  ' + numberFixed(legendData[index] * 100) + '%';
            }
        },
        grid: {
            height: 130,
            containLabel: true
        },
        calculable: true,
        color: ['#F99248', '#ED726C', '#2365C4', '#73CDFC', '#ACD598'],
        series: [{
            radius: ['40%', '70%'],
            center: ['18%', '48%'],
            minAngle: 20,
            hoverAnimation: false
        }],
        data: data
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/financial/DataTransitPie.jsx